site.activeImage = {
	init:function($container) {
		$container = $($container);
		if (!$container.length) {
			return;
		}
		var $activeImage = $container.find('.active__image .img');
		var $thumbs = $container.find('.active__image--thumbs');

		$thumbs.find('button').on('click mouseover', function() {
			var $thumbImg = $(this).find('.img');
			var $src = $thumbImg.css('background-image');
			$activeImage.css('background-image', $src);
			console.log($src);
		});
	}
};
